<script>
  import { fade } from "svelte/transition";
	import ProductScrollX from "../components/ProductScrollX.svelte"
					
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import News from "../components/News.svelte";
  import MenuIcons from "../components/MenuIcons.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Slider from "../components/Slider.svelte";

  import PopularProduct from "../components/PopularProduct.svelte";

  import { session } from "../components/js/notif.js";

  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = []; 
</script>

{#if alert.length > 0}
  <div class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar backbtn="false" message={navigation['message']} align="center" />
<main transition:fade class="container px-2 pt-24 mx-auto mb-20 lg:pt-24 md:pt-20">
  <div class="flex flex-wrap items-center pt-3 mx-auto center lg:my-0">
    <!--Main Col-->
    <Slider />
    <!--Img Col-->
    <MenuIcons />
  </div>

  <div class="mx-auto my-2 lg:my-0">
    <Title subtitle="Kabar seputar desa" title="Kabar Terkini" />
    <News load="3" />

    <Title
      title="Produk Desa"
      subtitle="Geliatkan Perekonomian Di Desa"
      tipe="3"
      href="./belanja" /> 
    <div class="relative">
      <PopularProduct />
    </div>
    <!--
    <Title subtitle="" title="Katalog" />
    <div class="flex w-full pb-3 mt-2 overflow-auto md:mt-0">
     <CardWraper items={listcatalog} classadd="" />
    </div> 
-->
    <ProductScrollX id="2801003" 
    title="Mulai Berkebun"
    subtitle="Lihat Lebih Banyak" 
    href="./belanja/c/rumah-tangga-taman-benih-bibit-tanaman/q/-"
    img="https://images.unsplash.com/photo-1594568838442-ccc2c521e12d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80" />

    <ProductScrollX id="18" parent="true"
    title="Calon Kenyang"
    subtitle="Lihat Lebih Banyak" 
    href="./belanja/c/makanan-minuman/q/-"
    img="https://images.unsplash.com/photo-1501959915551-4e8d30928317?ixlib=rb-1.2.1&auto=format&fit=crop&w=250&q=80" />
<!--
    <div class="hidden mt-10 separator lg:block">Testimoni</div>
    <div class="hidden w-full lg:block">
      <svg
        viewBox="-30 0 1500 374"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"><defs>
          <path
            d="M1061,202.5 C1061,196.70101 1065.70101,192 1071.5,192 L1275.5,192 C1281.29899,192 1286,196.70101 1286,202.5 L1286,291.5 C1286,297.29899 1281.29899,302 1275.5,302 L1087.66,302 L1065.80026,318.39901 C1064.47488,319.393264 1062.59445,319.124835 1061.60019,317.799457 C1061.2106,317.280123 1061,316.648421 1061,315.999202 L1061,202.5 Z"
            id="path-1" />
          <filter
            x="-12.4%"
            y="-15.7%"
            width="124.9%"
            height="144.1%"
            filterUnits="objectBoundingBox"
            id="filter-2">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M848,172.5 C848,166.70101 852.70101,162 858.5,162 L1062.5,162 C1068.29899,162 1073,166.70101 1073,172.5 L1073,241.5 C1073,247.29899 1068.29899,252 1062.5,252 L874.66,252 L852.800255,268.39901 C851.474878,269.393264 849.594445,269.124835 848.600192,267.799457 C848.210604,267.280123 848,266.648421 848,265.999202 L848,172.5 Z"
            id="path-3" />
          <filter
            x="-12.4%"
            y="-18.7%"
            width="124.9%"
            height="152.3%"
            filterUnits="objectBoundingBox"
            id="filter-4">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M329,171.5 C329,165.70101 333.70101,161 339.5,161 L543.5,161 C549.29899,161 554,165.70101 554,171.5 L554,240.5 C554,246.29899 549.29899,251 543.5,251 L355.66,251 L333.800255,267.39901 C332.474878,268.393264 330.594445,268.124835 329.600192,266.799457 C329.210604,266.280123 329,265.648421 329,264.999202 L329,171.5 Z"
            id="path-5" />
          <filter
            x="-12.4%"
            y="-18.7%"
            width="124.9%"
            height="152.3%"
            filterUnits="objectBoundingBox"
            id="filter-6">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M424,10.5 C424,4.70101013 428.70101,1.06525716e-15 434.5,0 L618.5,0 C624.29899,-1.06525716e-15 629,4.70101013 629,10.5 L629,79.5 C629,85.2989899 624.29899,90 618.5,90 L450.66,90 L428.800255,106.39901 C427.474878,107.393264 425.594445,107.124835 424.600192,105.799457 C424.210604,105.280123 424,104.648421 424,103.999202 L424,10.5 Z"
            id="path-7" />
          <filter
            x="-13.7%"
            y="-18.7%"
            width="127.3%"
            height="152.3%"
            filterUnits="objectBoundingBox"
            id="filter-8">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M654,20.5 C654,14.7010101 658.70101,10 664.5,10 L977.5,10 C983.29899,10 988,14.7010101 988,20.5 L988,107.5 C988,113.29899 983.29899,118 977.5,118 L680.66,118 L658.800255,134.39901 C657.474878,135.393264 655.594445,135.124835 654.600192,133.799457 C654.210604,133.280123 654,132.648421 654,131.999202 L654,20.5 Z"
            id="path-9" />
          <filter
            x="-8.4%"
            y="-16.0%"
            width="116.8%"
            height="144.8%"
            filterUnits="objectBoundingBox"
            id="filter-10">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M1248,157.5 C1248,151.70101 1252.70101,147 1258.5,147 L1462.5,147 C1468.29899,147 1473,151.70101 1473,157.5 L1473,226.5 C1473,232.29899 1468.29899,237 1462.5,237 L1274.66,237 L1252.80026,253.39901 C1251.47488,254.393264 1249.59445,254.124835 1248.60019,252.799457 C1248.2106,252.280123 1248,251.648421 1248,250.999202 L1248,157.5 Z"
            id="path-11" />
          <filter
            x="-12.4%"
            y="-18.7%"
            width="124.9%"
            height="152.3%"
            filterUnits="objectBoundingBox"
            id="filter-12">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M1012,13.5 C1012,7.70101013 1016.70101,3 1022.5,3 L1376.5,3 C1382.29899,3 1387,7.70101013 1387,13.5 L1387,140.5 C1387,146.29899 1382.29899,151 1376.5,151 L1039.635,151 L1016.75881,167.556127 C1015.41656,168.527489 1013.54101,168.226828 1012.56965,166.884583 C1012.19935,166.372899 1012,165.757395 1012,165.125777 L1012,13.5 Z"
            id="path-13" />
          <filter
            x="-7.5%"
            y="-12.1%"
            width="114.9%"
            height="133.9%"
            filterUnits="objectBoundingBox"
            id="filter-14">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M571,220.5 C571,214.70101 575.70101,210 581.5,210 L857.5,210 C863.29899,210 868,214.70101 868,220.5 L868,307.5 C868,313.29899 863.29899,318 857.5,318 L598.635,318 L575.758806,334.556127 C574.416561,335.527489 572.541012,335.226828 571.56965,333.884583 C571.199352,333.372899 571,332.757395 571,332.125777 L571,220.5 Z"
            id="path-15" />
          <filter
            x="-9.4%"
            y="-16.0%"
            width="118.9%"
            height="144.8%"
            filterUnits="objectBoundingBox"
            id="filter-16">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M501,89.5 C501,83.7010101 505.70101,79 511.5,79 L807.5,79 C813.29899,79 818,83.7010101 818,89.5 L818,172.5 C818,178.29899 813.29899,183 807.5,183 L528.635,183 L505.758806,199.556127 C504.416561,200.527489 502.541012,200.226828 501.56965,198.884583 C501.199352,198.372899 501,197.757395 501,197.125777 L501,89.5 Z"
            id="path-17" />
          <filter
            x="-8.8%"
            y="-16.5%"
            width="117.7%"
            height="146.2%"
            filterUnits="objectBoundingBox"
            id="filter-18">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M0,141.5 C-7.10171439e-16,135.70101 4.70101013,131 10.5,131 L304.5,131 C310.29899,131 315,135.70101 315,141.5 L315,210.5 C315,216.29899 310.29899,221 304.5,221 L26.66,221 L4.80025546,237.39901 C3.47487788,238.393264 1.59444525,238.124835 0.600191615,236.799457 C0.210604398,236.280123 -1.49927496e-12,235.648421 -1.5063506e-12,234.999202 L0,141.5 Z"
            id="path-19" />
          <filter
            x="-8.9%"
            y="-18.7%"
            width="117.8%"
            height="152.3%"
            filterUnits="objectBoundingBox"
            id="filter-20">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M97,25.5 C97,19.7010101 101.70101,15 107.5,15 L428.5,15 C434.29899,15 439,19.7010101 439,25.5 L439,114.5 C439,120.29899 434.29899,125 428.5,125 L123.66,125 L101.800255,141.39901 C100.474878,142.393264 98.5944453,142.124835 97.6001916,140.799457 C97.2106044,140.280123 97,139.648421 97,138.999202 L97,25.5 Z"
            id="path-21" />
          <filter
            x="-8.2%"
            y="-15.7%"
            width="116.4%"
            height="144.1%"
            filterUnits="objectBoundingBox"
            id="filter-22">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
          <path
            d="M136,246.5 C136,240.70101 140.70101,236 146.5,236 L445.5,236 C451.29899,236 456,240.70101 456,246.5 L456,315.5 C456,321.29899 451.29899,326 445.5,326 L162.66,326 L140.800255,342.39901 C139.474878,343.393264 137.594445,343.124835 136.600192,341.799457 C136.210604,341.280123 136,340.648421 136,339.999202 L136,246.5 Z"
            id="path-23" />
          <filter
            x="-8.8%"
            y="-18.7%"
            width="117.5%"
            height="152.3%"
            filterUnits="objectBoundingBox"
            id="filter-24">
            <feOffset
              dx="0"
              dy="8"
              in="SourceAlpha"
              result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="8"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
              type="matrix"
              in="shadowBlurOuter1" />
          </filter>
        </defs>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd">
          <g
            id="Desktop-HD-Copy-7"
            transform="translate(0.000000, -2556.000000)">
            <g id="Group-19" transform="translate(-16.000000, 2564.000000)">
              <g id="Combined-Shape-1">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-2)"
                  xlink:href="#path-1" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1" />
              </g>
              <text
                id="James-Keillor"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="1166.21526" y="276">James Keillor</tspan>
              </text>
              <text
                id="Fantastic-app,-works"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="1089" y="224">Fantastic app, works great</tspan>
                <tspan x="1089" y="244">and super easy to use</tspan>
              </text>
              <g id="Combined-Shape-2">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-4)"
                  xlink:href="#path-3" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-3" />
              </g>
              <text
                id="Zhao-Qing-Koh"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="942.547263" y="226">Zhao Qing Koh</tspan>
              </text>
              <text
                id="Sleek-and-simple-to"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="876" y="194">Sleek and simple to use.</tspan>
              </text>
              <g id="Combined-Shape-3">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-6)"
                  xlink:href="#path-5" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-5" />
              </g>
              <text
                id="Majeed-Zoabi"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="433.167474" y="225">Majeed Zoabi</tspan>
              </text>
              <text
                id="Sleek-and-profession"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="357" y="193">Sleek and professional!</tspan>
              </text>
              <g id="Combined-Shape-4">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-8)"
                  xlink:href="#path-7" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-7" />
              </g>
              <text
                id="Auke-van-der-Meer"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="471.896421" y="64">Auke van der Meer</tspan>
              </text>
              <text
                id="Just-perfect."
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="452" y="32">Just perfect.</tspan>
              </text>
              <g id="Combined-Shape-5">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-10)"
                  xlink:href="#path-9" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-9" />
              </g>
              <text
                id="Jaga-My-Priera"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="858.133053" y="94">Jaga My Priera</tspan>
              </text>
              <text
                id="Sleek-design,-easy-t"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="682" y="42">
                  Sleek design, easy to use, and well written code.
                </tspan>
                <tspan x="682" y="62">
                  Oh, and I love the paper wallet feature.
                </tspan>
              </text>
              <g id="Combined-Shape-6">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-12)"
                  xlink:href="#path-11" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-11" />
              </g>
              <text
                id="Bryan-Lemyre"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="1348.93347" y="211">Bryan Lemyre</tspan>
              </text>
              <text
                id="Great,-fast,-always"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="1276" y="179">Great, fast, always works.</tspan>
              </text>
              <g id="Combined-Shape-7">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-14)"
                  xlink:href="#path-13" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-13" />
              </g>
              <text
                id="Natrium-is-easily-th"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="1040" y="35">
                  Natrium is easily the most robust and intuitive Nano
                </tspan>
                <tspan x="1040" y="55">
                  wallet. It gives the most control over your wallet’s
                </tspan>
                <tspan x="1040" y="75">
                  security, contacts, and representative choice. Sending
                </tspan>
                <tspan x="1040" y="95">
                  and receiving couldn’t be easier. Highly recommended.
                </tspan>
              </text>
              <text
                id="Nate-Ryan"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="1287.84611" y="127">Nate Ryan</tspan>
              </text>
              <g id="Combined-Shape-8">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-16)"
                  xlink:href="#path-15" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-15" />
              </g>
              <text
                id="Sonel-Prabhakaran"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="714.476421" y="294">Sonel Prabhakaran</tspan>
              </text>
              <text
                id="Fast,-reliable,-easy"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="599" y="242">
                  Fast, reliable, easy to use and looks great.
                </tspan>
                <tspan x="599" y="262">What more could you want?</tspan>
              </text>
              <g id="Combined-Shape-9">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-18)"
                  xlink:href="#path-17" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-17" />
              </g>
              <text
                id="Shivang-Saxena"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="681.413053" y="163">Shivang Saxena</tspan>
              </text>
              <text
                id="Amazing-UI,-great-se"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="529" y="111">
                  Amazing UI, great security, push notifications,
                </tspan>
                <tspan x="529" y="131">
                  I’m not sure I could ask for anything else.
                </tspan>
              </text>
              <g id="Combined-Shape-10">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-20)"
                  xlink:href="#path-19" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-19" />
              </g>
              <text
                id="Dalibor-Rile"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="207.747474" y="195">Dalibor Rile</tspan>
              </text>
              <text
                id="Works-great,-easy-an"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="28" y="163">
                  Works great, easy and fast, excellent design!
                </tspan>
              </text>
              <g id="Combined-Shape-11">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-22)"
                  xlink:href="#path-21" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-21" />
              </g>
              <text
                id="Andre-Görgens"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="307.091263" y="99">Andre Görgens</tspan>
              </text>
              <text
                id="Really-great-working"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="125" y="47">
                  Really great working wallet. And it looks beautiful,
                </tspan>
                <tspan x="125" y="67">
                  love it! Best crypto wallet app I’ve seen so far.
                </tspan>
              </text>
              <g id="Combined-Shape-12">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-24)"
                  xlink:href="#path-23" />
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-23" />
              </g>
              <text
                id="Felix-Dolderer"
                opacity="0.6"
                font-size="14"
                font-weight="bold"
                line-spacing="20"
                letter-spacing="-0.0257894741"
                fill="#383C44">
                <tspan x="331.131053" y="300">Felix Dolderer</tspan>
              </text>
              <text
                id="Stylish,-easy-to-use"
                opacity="0.75"
                font-size="12"
                font-weight="normal"
                line-spacing="20"
                letter-spacing="-0.0221052635"
                fill="#383C44">
                <tspan x="164" y="268">
                  Stylish, easy to use and speedy performance.
                </tspan>
              </text>
            </g>
          </g>
        </g></svg>
    </div>
  -->
  </div>
</main>
